import classes from '../../constants/classes';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const body = document.body;

export class ZoomTrigger extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    this.touchMoving = false;

    this.init();
  }

  init() {
    this.bindTouchHandlers();
    this.bindClickHandler();
  }

  bindTouchHandlers() {
    this.touchStartHandler = this.handleTouchStart.bind(this);
    window.addEventListener('touchstart', this.touchStartHandler);

    this.touchMoveHandler = this.handleTouchMove.bind(this);
    window.addEventListener('touchmove', this.touchMoveHandler);

    this.element.addEventListener('touchend', (e) => {
      if (!body.classList.contains(classes.SWIPING) && !this.touchMoving) {
        e.preventDefault();
        this.openZoom(e.type);
      }
    });
  }

  handleTouchStart() {
    this.touchMoving = false;
  }

  handleTouchMove() {
    this.touchMoving = true;
  }

  bindClickHandler() {
    this.element.addEventListener('click', (e) => {
      if (!body.classList.contains(classes.SWIPING)) {
        e.preventDefault();
        this.openZoom(e.type);
      }
    });
  }

  openZoom(eventType) {
    dispatchEvent(window, events.OPEN_ZOOM, {
      eventType: eventType,
      image: this.element
    });
  }

  cleanup() {
    window.removeEventListener('touchstart', this.touchStartHandler);
    window.removeEventListener('touchmove', this.touchMoveHandler);
  }
}